//expecting value to be an legal number
//FE_BE contract:
//- values in range are in closed interval
//- if one the range value is missing, the validation is performed only on the other

import { WEBUILogs } from "../logging";

//- if there is range with missig value - no validation will be performed
export default function(toValidate, options = {}) {
    //do not need to check undefined and null or empty string
    //zero is a valid number to be checked is in range
    if (typeof toValidate === undefined || toValidate === null || toValidate === "") {
        return true;
    }
    if (isNaN(toValidate)) {
        WEBUILogs.log("Range validation failed due to illegal  number!");
        return false;
    }
    let range = options.range || {};

    // exclude array with values from validation
    let exclusionFlag = false;
    if (range.hasOwnProperty("excludedValues") && range.excludedValues.length > 0) {
        exclusionFlag = range.excludedValues.includes(toValidate);
    }

    if (range.hasOwnProperty("top") && range.hasOwnProperty("bottom")) {
        return exclusionFlag || (toValidate >= range.bottom && toValidate <= range.top);
    }

    if (range.hasOwnProperty("bottom")) {
        return exclusionFlag || toValidate >= range.bottom;
    }

    if (range.hasOwnProperty("top")) {
        return exclusionFlag || toValidate <= range.top;
    }

    return true;
}
